/* unplugin-vue-components disabled */import { render } from "./BusinessSmsCaptcha.vue?vue&type=template&id=384a791a&ts=true"
import script from "./BusinessSmsCaptcha.vue?vue&type=script&lang=ts"
export * from "./BusinessSmsCaptcha.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__